<template>
	<div class="tabs-component">
		<ul role="tablist" class="tabs-component-tabs list-reset flex flex-wrap -mx-px justify-start">
			<li v-for="(tab, i) in tabs"
				:key="i"
				:class="{ 'text-white': tab.isActive, 'bg-transparent': tab.isDisabled }"
				class="tabs-component-tab w-full md:w-auto inline-block px-px flex-grow md:flex-grow-0 text-center"
				role="presentation"
				v-show="tab.isVisible">
				<a v-html="tab.header"
				   :aria-controls="tab.hash"
				   :aria-selected="tab.isActive"
				   @click="selectTab(tab.hash, $event)"
				   :href="tab.hash"
				   :class="{ 'bg-white text-purple-500 hover:text-blue-500 shadow-purple-light-lg': tab.isActive, 'bg-purple-100 text-purple-300': tab.isDisabled }"
				   class="tabs-component-tab-a w-full md:w-auto inline-block text-purple-400 hover:text-blue-400 py-2 px-4 mb-2 md:mb-0 rounded-lg md:rounded-b-none"
				   role="tab">
				</a>
			</li>
		</ul>
		<div class="tabs-component-panels w-full">
			<slot/>
		</div>
	</div>
</template>

<script>

	import expiringStorage from '../expiringStorage';

	export default {
		name: "Tabs",
		props: {
			cacheLifetime: {
				default: 5,
			},
			options: {
				type: Object,
				required: false,
				default: () => ({
					useUrlFragment: true,
				}),
			},
		},
		data: () => ({
			tabs: [],
			activeTabHash: '',
		}),
		computed: {
			storageKey() {
				return `vue-tabs-component.cache.${window.location.host}${window.location.pathname}`;
			},
		},
		created() {
			this.tabs = this.$children;
		},
		mounted() {
			window.addEventListener('hashchange', () => this.selectTab(window.location.hash));
			if (this.findTab(window.location.hash)) {
				this.selectTab(window.location.hash);
				return;
			}
			const previousSelectedTabHash = expiringStorage.get(this.storageKey);
			if (this.findTab(previousSelectedTabHash)) {
				this.selectTab(previousSelectedTabHash);
				return;
			}
			if (this.tabs.length) {
				this.selectTab(this.tabs[0].hash);
			}
		},
		methods: {
			findTab(hash) {
				return this.tabs.find(tab => tab.hash === hash);
			},
			selectTab(selectedTabHash, event) {
				// See if we should store the hash in the url fragment.
				if (event && !this.options.useUrlFragment) {
					event.preventDefault();
				}
				const selectedTab = this.findTab(selectedTabHash);
				if (!selectedTab) {
					return;
				}
				if (selectedTab.isDisabled) {
					return;
				}
				this.tabs.forEach(tab => {
					tab.isActive = (tab.hash === selectedTab.hash);
				});
				this.$emit('changed', {tab: selectedTab});
				this.activeTabHash = selectedTab.hash;
				expiringStorage.set(this.storageKey, selectedTab.hash, this.cacheLifetime);
			},
			setTabVisible(hash, visible) {
				const tab = this.findTab(hash);
				if (!tab) {
					return;
				}
				tab.isVisible = visible;
				if (tab.isActive) {
					// If tab is active, set a different one as active.
					tab.isActive = visible;
					this.tabs.every((tab, index, array) => {
						if (tab.isVisible) {
							tab.isActive = true;
							return false;
						}
						return true;
					});
				}
			},
		},
	}
</script>

<style scoped>

</style>
